import { ActionIcon, Affix, AppShell, Transition } from "@mantine/core";
import { ArrowUpIcon } from "@phosphor-icons/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

// import { Footer } from "./-components/Footer";
import { Navbar } from "@/features/dashboard/_components/Navbar";
import { useAppShellContext } from "@/features/dashboard/_context/appShellContext";
import { useAtBottom } from "@/hooks";
import { Role } from "@/store";

export const Route = createFileRoute("/_private/dashboard")({
  component: Dashboard,
  beforeLoad: () => {
    return {
      role: sessionStorage.getItem("@App:userRole") as Role
    };
  },
  head: () => ({
    meta: [{ title: "Dashboard" }]
  })
});

function Dashboard() {
  const { props } = useAppShellContext();

  return (
    <AppShell {...props}>
      <Outlet />

      <AppShell.Navbar p="md">
        <Navbar />
      </AppShell.Navbar>

      {/* <AppShell.Footer p="md">
        <Footer />
      </AppShell.Footer> */}
    </AppShell>
  );
}

function _UpScrollBtn() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { atBottom, scroll, scrollTo } = useAtBottom();

  return (
    <Affix position={{ bottom: atBottom ? 115 : 20, right: 20 }}>
      <Transition transition="slide-up" mounted={scroll.y > 0}>
        {(transitionStyles) => (
          <ActionIcon style={transitionStyles} onClick={() => scrollTo({ y: 0 })} size="xl" variant="light">
            <ArrowUpIcon />
          </ActionIcon>
        )}
      </Transition>
    </Affix>
  );
}
